import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ToneType } from '../types/index';

interface SettingsState {
  // User preferences
  defaultTone: ToneType;
  voiceAdoptionEnabled: boolean;

  // Actions
  setDefaultTone: (tone: ToneType) => void;
  setVoiceAdoptionEnabled: (enabled: boolean) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      defaultTone: 'formal',
      voiceAdoptionEnabled: false,

      setDefaultTone: (tone) => set({ defaultTone: tone }),
      setVoiceAdoptionEnabled: (enabled) => set({ voiceAdoptionEnabled: enabled }),
    }),
    {
      name: 'autoresponder-settings',
    }
  )
);
